<svelte:options customElement="start-button" />

<script lang="ts">
	import "./icons/logo.svelte";
	import "./icons/building.svelte";
	import { onMount } from "svelte";

	interface Props {
		text: string;
		client: string;
		flowid: string;
		tag: string;
		redirecturl: string;
	}

	let { text, client, flowid, tag, redirecturl }: Props = $props();

	const PUBLIC_ONBOARDING_URL = import.meta.env.VITE_ONBOARDING_URL;
	let searchParams: string | null = $state(null);
	onMount(() => {
		const search = new URLSearchParams();
		if (tag) search.set("tag", tag);
		if (redirecturl) search.set("redirectUrl", redirecturl);
		searchParams = search.toString();
	});
</script>

<a href={`${PUBLIC_ONBOARDING_URL}start/${client}/${flowid}?${searchParams}`}>
	<icon-building></icon-building>
	{text}
</a>

<style>
	a {
		background: #fff;
		border-radius: 0.5rem;
		color: #172e44;
		border: 1px solid #dcdcdc;
		font-weight: 400;
		font-size: 14px;
		text-decoration: none;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		padding: 1rem 0;
		cursor: pointer;
	}
</style>
